import {removeTokenCookie, removeUserCookie, setTokenCookie, setUserCookie} from 'libs/cookie'
import {useRouter} from 'next/router'
import * as React from 'react'
import {UsersApi} from "services";
import {UserLogin} from "services/types";

// @ts-ignore
const AuthContext = React.createContext<AuthHook>({})

export function AuthProvider({children}) {
    const auth = useFirebaseAuth()

    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
    return React.useContext(AuthContext)
}

type AuthHook = {
    user: UserLogin,
    loading: boolean
    signInWithEmailAndPassword: (email: string, password: string, type: number, redirect?: string) => Promise<string>
    signout: (data: any) => Promise<void>
}

function useFirebaseAuth(): AuthHook {
    const [user, setUser] = React.useState<UserLogin | null>(null)
    const [loading, setLoading] = React.useState(true)
    // const [message, setMessage] = React.useState(null)
    const router = useRouter()

    const handleUser = React.useCallback(async (rawUser?: any, newRegister = false): Promise<void> => {
        if (rawUser) {
            // const user = await formatUser(rawUser)

            setTokenCookie(rawUser.accessToken)
            // setUserCookie(user.user)
            // setUser(user)
            setLoading(false)
        } else {
            removeTokenCookie()
            removeUserCookie()
            setUser(null)
            setLoading(false)
        }
    }, [])

    const signInWithEmailAndPassword = async (email: string, password: string, type: number, redirect?: string): Promise<string> => {
        setLoading(true)
        try {
            const api = new UsersApi()
            const data = await api.postLogin(email, password, type)
            if (data.isFailure) {
                return 'Username or Password is wrong';
            }
            var user = data?.getValue().data
            if (!user.accessToken) {
                return 'Username or Password is wrong';
            }
            setUserCookie({username: email, type: type})
            await handleUser(user, false)
            await router.push(redirect ?? '/')
        } catch (e) {
            return 'Username or Password is wrong';
        }
        setLoading(false)
    }

    const signout = async ({redirectTo}) => {
        handleUser(undefined)
        removeTokenCookie()
        removeUserCookie()
        setUser(null)
        router.push(redirectTo)
    }

    return {
        user,
        loading,
        signInWithEmailAndPassword,
        signout,
    }
}

// const formatUser = async (user: any): Promise<UserLogin> => {
//     return user
// }
